import { render, staticRenderFns } from "./PrivacyUserSettings.vue?vue&type=template&id=68958b96&scoped=true&"
import script from "./PrivacyUserSettings.vue?vue&type=script&lang=js&"
export * from "./PrivacyUserSettings.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyUserSettings.vue?vue&type=style&index=0&id=68958b96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68958b96",
  null
  
)

export default component.exports